import { render, staticRenderFns } from "./Vendas.vue?vue&type=template&id=172add02&"
import script from "./Vendas.vue?vue&type=script&lang=ts&"
export * from "./Vendas.vue?vue&type=script&lang=ts&"
import style0 from "./Vendas.vue?vue&type=style&index=0&id=172add02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports